export default __webpack_public_path__ + "2e581f55b725ba8893b2cc6d57f32258.png";